import { render } from "./ManageUsersSuperAdminOverlay.vue?vue&type=template&id=457b1898&scoped=true&lang=pug"
import script from "./ManageUsersSuperAdminOverlay.vue?vue&type=script&lang=js"
export * from "./ManageUsersSuperAdminOverlay.vue?vue&type=script&lang=js"

import "./ManageUsersSuperAdminOverlay.vue?vue&type=style&index=0&id=457b1898&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457b1898"]])

export default __exports__